import { Component, ViewEncapsulation, OnChanges, SimpleChanges } from '@angular/core';

import { Antwoord } from '@models/claims';
import { Uploadfile, VraagboomUploadResultaat } from '@models/vragenboom';
import { BaseSummaryControlDirective } from '../base/base-summary-control';
import { ImageHelper } from '../../../utils/helpers/image-helper';

@Component({
  selector: 'app-multiupload-summary',
  templateUrl: './multiupload-summary.component.html',
  styleUrls: ['./multiupload-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MultiUploadSummaryComponent extends BaseSummaryControlDirective<VraagboomUploadResultaat> implements OnChanges {
  antwoorden: Antwoord[] = [];
  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.antwoordResultaat != null &&
      this.antwoordResultaat.vraag != null && this.antwoordResultaat.vraag.antwoorden != null &&
      this.antwoordResultaat.antwoorden != null) {

      this.antwoorden = [];
      for (const antwoord of this.antwoordResultaat.vraag.antwoorden) {
        if (this.antwoordResultaat.antwoorden.findIndex(a => a.id === antwoord.id) >= 0) {
          this.antwoorden.push(antwoord);
        }
      }
    }
  }

  resultaatGroep(antw: Antwoord): Uploadfile[] {
    return this.antwoordResultaat.resultaat.uploadedFiles.filter(uf => uf.groepId === antw.groep_id);
  }

  isFileImage(filename: string): boolean {
    return ImageHelper.isFileImage(filename);
  }
}
